import { eventTypes } from '../constants/eventEnums';

const ENDPOINTS = {
  EVENT_OFF: 'Event/Off',
  EVENT_COLOR: 'Event/Color',
  EVENT_SCENE: 'Event/Scene'
};

export const selectEventUrl = (eventType: number) => {
  let url = '';
  switch (eventType) {
    case eventTypes.OFF_EVENT:
      url = ENDPOINTS.EVENT_OFF;
      break;
    case eventTypes.COLOR_EVENT:
      url = ENDPOINTS.EVENT_COLOR;
      break;
    case eventTypes.SCENE_EVENT:
      url = ENDPOINTS.EVENT_SCENE;
      break;
    default:
      url = '';
      break;
  }
  return url;
};
